// extracted by mini-css-extract-plugin
export default {"menu":"BidAskContextMenu_menu__vnScx"};